import { IHeaderButtonCallback } from "../common/contextmenu"

export const buttonCallbacks: Record<string, IHeaderButtonCallback> = {}

interface OldUIInit {
    registerButton: (actionId: string, callback: IHeaderButtonCallback) => void
}

const init = (): OldUIInit => {
    const registerButton = (
        actionId: string,
        callback: IHeaderButtonCallback,
    ): void => {
        buttonCallbacks[actionId] = callback
    }

    return {
        registerButton,
    }
}

export default init
